export const JavalabEditorDialog = {
  RENAME_FILE: 'RENAME_FILE',
  DELETE_FILE: 'DELETE_FILE',
  CREATE_FILE: 'CREATE_FILE',
  COMMIT_FILES: 'COMMIT_FILES',
  VERSION_HISTORY: 'VERSION_HISTORY',
};
